import { Injectable } from '@angular/core';

export interface UnsavedChangesSource {
  hasUnsavedChanges(): boolean;
  /** The user chose Discard: stop warning (e.g. the page's own leave guard) for this page. */
  discardChanges(): void;
}

/**
 * Lets the page that owns an editable form tell app-wide controls (the Global Event Selector)
 * that leaving now would discard changes (EVT-US-04 §45–46).
 */
@Injectable({ providedIn: 'root' })
export class UnsavedChangesService {
  private source: UnsavedChangesSource | null = null;

  register(source: UnsavedChangesSource): void {
    this.source = source;
  }

  /** Clears only the given source so a page being destroyed cannot drop a newer page's source. */
  unregister(source: UnsavedChangesSource): void {
    if (this.source === source) {
      this.source = null;
    }
  }

  hasUnsavedChanges(): boolean {
    return !!this.source && this.source.hasUnsavedChanges();
  }

  discardChanges(): void {
    this.source?.discardChanges();
  }
}
